/* eslint-disable */
import {
  PAIRING_ENDPOINT,
  PAIRING_TIMEOUT,
  CODE_LENGTH
} from './constants.js';
import './styles/default.less';


(function(global) {
  function extractCodeFromHash() {
    if(window.location.hash) {
      var code = (window.location.hash.match(/^#code=(\d+)/) || []).pop();
      if(code) {
        window.document.querySelector('#code').value = global.formatCode(code);
      }
    }
  };

  function getToken(code, callback) {
    var req = new XMLHttpRequest();
    req.addEventListener('load', function() {
      if(this.status !== 200) {
        alert('Unknown code entered. Please try again.');
      } else {
        try {
          callback(JSON.parse(this.responseText).token);
        } catch(e) {
          alert('Unknown error occured while parsing authentication token. Please contact support.');
        }
      }
    });
    req.addEventListener('error', function() {
      alert('Unknown error occured while attempting to contact pairing code server. Please contact support.');
    });
    req.open('GET', PAIRING_ENDPOINT + '/api/code/' + parseInt(code, 10));
    req.send();
  }

  function establishConnection(code, onSuccess, onError) {
    getToken(code, function(token) {
      var decodedTokenBody,
          req;

      try {
        decodedTokenBody = JSON.parse(atob(token.split('.')[1]));
        if(!decodedTokenBody.iss || !decodedTokenBody.ssid) {
          throw new Error();
        }
      } catch(e) {
        return onError('Invalid authentication token supplied. Please contact support.');
      }

      req = new XMLHttpRequest();
      req.addEventListener('load', function() {
        if(this.status === 201) {
          onSuccess();
        } else if(this.status === 200) {
          onError('This device is already paired.');
        } else {
          onError('Could not establish pairing. Please contact support.');
        }
      });
      ['error', 'timeout'].forEach(function(eventName) {
        req.addEventListener(eventName, function() {
          onError('Could not establish pairing. Please try to connect to the "' + decodedTokenBody.ssid + '" WiFi network and refresh this page.');
        });
      });
      req.open('POST', decodedTokenBody.iss + '/pair');
      req.timeout = PAIRING_TIMEOUT;
      req.setRequestHeader('Authorization', 'Bearer ' + token);
      req.send();
    });
  }

  function connect(textualCode, hasAcceptedTos) {
    if(!hasAcceptedTos) {
      alert('Please accept the Terms of Service before connecting');
      return;
    }

    var code = (textualCode || '').replace(/[^\d]/g, '');

    if(code.length === CODE_LENGTH) {
      global.establishConnection(code, function() {
        document.getElementById('entry').style.display = 'none';

        var connectedBlock = document.getElementById('connected');
        connectedBlock.style.display = 'block';
        window.scrollTo(0, 0);
      }, function(error) {
        alert(error);
      });
    }
  }

  global.formatCode = function(code) {
    return ((code || '').replace(/[^\d]/g, '').match(/\d{1,3}/g) || []).join(' ');
  };

  global.reformatInput = function(input) {
    var currentValue = input.value,
        caretPosition = input.selectionStart;

    if(caretPosition === currentValue.length ||
       currentValue.replace(/\s/g, '').length === CODE_LENGTH) {
      input.value = global.formatCode(currentValue);
      caretPosition += input.value.length - currentValue.length;
    }

    setTimeout(function() {
      input.selectionStart = input.selectionEnd = caretPosition;
    }, 0);
  };

  global.establishConnection = establishConnection;
  global.connect = connect;

  window.document.addEventListener('DOMContentLoaded', extractCodeFromHash);
  window.addEventListener('hashchange', extractCodeFromHash);
})(window.sonifi || (window.sonifi = {}));



// WEBPACK FOOTER //
// ./bootstrap.js